export { default } from './DetailsHeader';
